import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Icons from '../../../../../../common/widgets/Icons';
import { resources } from '../../../../resources/resources';

interface ITimeAndAttendaceCheckIn {
  isTimesheetBlocked: boolean;
}
export const TimeAndAttendaceCheckIn = (props: ITimeAndAttendaceCheckIn) => {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();

  return (
    <div className="taa-check-in-wrapper">
      <button
        disabled={props.isTimesheetBlocked}
        className="btn btn-outline"
        onClick={() => navigate('/my-account/time-and-attendance/check-in')}
      >
        <span className="btn-icon">
          <Icons.ArrowButton />
        </span>
        <span className="btn-text">
          {translate(resources.timeAndAttendance.checkInButton)}
        </span>
      </button>
    </div>
  );
};
